import { render, staticRenderFns } from "./TagTableForm.vue?vue&type=template&id=f4d4fbf0&"
import script from "./TagTableForm.vue?vue&type=script&lang=js&"
export * from "./TagTableForm.vue?vue&type=script&lang=js&"
import style0 from "./TagTableForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports